import { Box, Typography } from '@mui/material';

function buildYouTubeEmbedSrc(videoId) {
  const params = new URLSearchParams({
    rel: '0',
    modestbranding: '1',
    playsinline: '1',
  });
  if (typeof window !== 'undefined') {
    params.set('origin', window.location.origin);
  }
  return `https://www.youtube.com/embed/${encodeURIComponent(
    videoId
  )}?${params.toString()}`;
}

export default function VideoStep({ videoId, description }) {
  const embedSrc = buildYouTubeEmbedSrc(videoId);

  return (
    <Box>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 0.5 }}>
        {description}
      </Typography>
      <Box
        sx={{
          position: 'relative',
          width: '100%',
          pt: '56.25%',
          mt: 2,
          borderRadius: 2,
          overflow: 'hidden',
          bgcolor: 'common.black',
          border: '1px solid',
          borderColor: 'grey.300',
          boxShadow: '0 4px 16px rgba(0,0,0,0.12), 0 2px 6px rgba(0,0,0,0.08)',
        }}
      >
        <iframe
          src={embedSrc}
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            border: 0,
          }}
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
          loading="lazy"
          title="Training video"
        />
      </Box>
    </Box>
  );
}
